import axiosInstance from "@/composables/axios-instance";
import router from "@/router";
import { toast } from "vue3-toastify";

const state = {
  factorItemsList: [],
  factorsList: [],
  factorDetail: []
};
const getters = {
  getFactorItemsList(state) {
    return state.factorItemsList;
  },
  getFactorsList(state) {
    return state.factorsList;
  },
  getFactorDetail(state){
    return state.factorDetail;
  }
};
const mutations = {
  setFactorItemsList(state, list) {
    state.factorItemsList = list;
  },
  setFactorsList(state, list) {
    state.factorsList = list;
  },
  setFactorDetail(state, detail){
    state.factorDetail = detail;
  }
};
const actions = {
  /* eslint-disable */
  createFactorItem({ }, item) {
    let requestData = {};
    for (let key in item) {
      requestData[key] = item[key];
    }
    return axiosInstance
      .post("/factor/item/create/", requestData)
      .then(response => {
        toast.success("کالا با موفقیت به فاکتور افزوده شد");
      })
      .catch(error => {
        console.error(error);
        toast.error("کالا به فاکتور افزوده نشد لطفا بعدا تلاش کنید");
      });
  },
  updateFactorItem({ }, item) {
    let requestData = {};
    for (let key in item) {
      requestData[key] = item[key];
    }
    return axiosInstance
      .put("/factor/item/update/", requestData, {params:{id: item.id}})
      .then(response => {
        toast.success("کالا با موفقیت تغییر یافت");
      })
      .catch(error => {
        console.error(error);
        toast.error("کالا تغییر نیافت لطفا بعدا تلاش کنید");
      });
  },
  deleteFactorItem({ }, id) {
    return axiosInstance.delete("/factor/item/delete/", {params:{id}}).then(response => {
      toast.success("کالا با موفقیت از فاکتور شما حذف شد");
    }).catch(error => {
      toast.error("متاسفانه کالا از فاکتور شما حذف نشد لطفا بعدا تلاش کنید")
    })
  },
  getFactorItemsFromApi({ commit }, username) {
    return axiosInstance
      .post("/factor/item/report/", {
        create_by: username,
      })
      .then((response) => {
        commit("setFactorItemsList", response.data);
      })
      .catch((error) => {
        toast.error("مشکلی پیش آمده لطفا بعدا تلاش کنید");
      });
  },
  createFactor({ }, factor) {
    return (
      axiosInstance
        .postForm("/factor/create/", factor)
        /* eslint-disable */
        .then((response) => {
          toast.success("فاکتور با موفقیت ایجاد شد");
        })
        .catch((error) => {
          console.error(error);
          toast.error("فاکتور ساخته نشد لطفا بعدا تلاش کنید");
        })
    );
  },
  deleteFactor({ }, id) {
    return axiosInstance.delete("/factor/delete/", {params:{id}}).then(response => { toast.success("فاکتور با موفقیت حذف شد") }).catch(error => {
      toast.error("متاسفانه فاکتور حذف نشد لطفا بعدا تلاش کنید");
      console.error(error);
    })
  },
  editFactor({ }, factor) {
    let requestData = {};
    for (let key in factor) {
      if (key != 'id')
        requestData[key] = factor[key];
    }
    return axiosInstance.put("/factor/update/", requestData, {params:{id: factor.id}}).then(response => { toast.success("فاکتور با موفقیت تغییر یافت") }).catch(error => { toast.error("متاسفانه فاکتور تغییر نیافت لطفا بعدا تلاش کنید") });
  },
  getFactorsListFromApi({ commit }, filter) {
    let requestData = {};
    for (let key in filter) {
      if (filter[key]) {
        requestData[key] = filter[key];
      }
    }
    return axiosInstance
      .post("/factor/report/", requestData, {params: {page_size:20, page: filter.page, date_range: filter.date_range}})
      .then((response) => {
        commit("setFactorsList", response.data);
      })
      .catch((error) => {
        if(error.status == 403)
          router.push({name: "dashboard"});
        else
          toast.error("لیست فاکتورها دریافت نشد لطفا بعدا تلاش کنید");
      });
  },
  getFactorDetailFromApi({commit}, id){
    return axiosInstance.get("/factor/detail/", {params: { id }}).then(response =>{
      commit("setFactorDetail", response.data);
    }).catch(error=>{
      toast.error("اطلاعات دریافت نشد لطفا بعدا تلاش کنید")
    })
  },
  getFactorsExcel() {
    return axiosInstance
      .get("/factor/excel/", {
        responseType: "blob"
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const filename = "Factors List.xlsx";
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error("Error:", err));
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
